import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
import { parseJwt } from "../components/utilities/utils";
// const header =
//   "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJYZXlIVWo0MTdmRUh2MDBZUHVRa3VRd2RGRXk5Z2JtU0NnSXRsZmNiNjdBIn0.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.Zxvyodk7Lr6lyWfj6NpXGfZ4hg53MXFVi6VynUUisiqUFtv19lpcQ8vsS4p0NYP4njonGNfnCWfMbEMuRaZqjLtqvck2n2_SPHuXMsQkuRQZUV8UIj3EnLHrXMqtvGsXjEX-I9GdfHDPgW6ykoXzherHB4KyWt62sO_iNjjD7pR2HIDF9SgaEflqgaZTageBkRe8ilMC-zsTPLwRZNRbkfW6vUOnYPVJ7IDZF1vR6k4Dh7f0yHZREpq4DaWGgLAXM0XyMZVebqQSUpi3bP1DVrmhkYHak3nBASNHulJFoq_TBORoKIsgOQxmynAZq-E0ft6nbXeXqvIT37X8fIxhMQ";

export const reportsServicesApi = createApi({
  reducerPath: "reportsServicesApi",
  keepUnusedDataFor:0.001,
  baseQuery: fetchBaseQuery({ baseUrl:BASE_URLS.REPORT_BASE_URL,
    prepareHeaders: (headers) => {
      // headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      return headers;
    }, 
  }),
  endpoints: (builder) => ({
    ///////////////////////////////////////////////////////////////////////:-CEO REPORT

    GetEpbGenerationDownloadCeoReport: builder.query({
      query: (constType) => ({
        url: `/v1/public/etpbs-reports/ceoPostalBallot/${constType}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    GetEpbScanningCeoReport: builder.query({
      query: (constType) => ({
        url: `/v1/public/etpbs-reports/getEPostalBallotScanningByCEO/${constType}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    GetCountingSupervisorCeoReport: builder.query({
      query: (data) => ({
        url: `/v1/public/etpbs-reports/getEpbGenerationReportCEO/${data.constituencyType}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getErollFinalizationStatusCeoReports: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getErollFinalised`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          // state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    ///////////////////////////////////////////////////////////////////////:-DEO REPORT
    GetEpbGenerationDownloadDeoReport: builder.query({
      query: (constType) => ({
        url: `/v1/public/etpbs-reports/deoPostalBallot/${constType}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    GetEpbScanningDeoReport: builder.query({
      query: (data) => ({
        url: `/v1/public/etpbs-reports/getEPostalBallotScanningByDEO/${data}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    GetCountingSupervisorDeoReport: builder.query({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getCountigSuperwiserDeo/${data}`,
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getErollFinalizationStatusDeoReports: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getErollFinalised`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          // state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    //////////////////////////////////////////////////////////////ECI OFFICER REPORT
    getEpbGenerationEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getEpbGenerationReport`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    
    getEpbDownloadStatewiseEciReport: builder.mutation({
      query: (data) => ({
        url: `/v1/public/etpbs-reports/getEpbStatus`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    getEpbDownloadForceWiseEciReport: builder.mutation({
      query: (data) => ({
        url: `/v1/public/etpbs-reports/getEpbStatusForce`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    getEpbDownloadRecordOfficeWiseEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getEpbStatusRo`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    getEpbDownloadUnitOfficeWiseEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getEpbStatusUo`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    getEpbScanningEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getEPostalBallotScanning`,
        method: 'POST',
        body: data,
        headers: {
          Authorization: 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
          currentrole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    getCountingSupervisorEciReport: builder.mutation({
      query: (data) => ({
        
        url: `v1/public/etpbs-reports/getCountigSuperwiser`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
         'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    GetStatesStatusForceWise: builder.query({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getStateStatusForce`,
        method: "GET",
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),

    GetForceWingData: builder.query({
      query: () => ({
        url: "v1/public/etpbs-reports/forceWingDetails",
        method: "GET",
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    ////////////////////////////////////////////////////////////RO REPORT
    GetEpbGenerationDownloadRoReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getEpbGenDownloadedBookedStatusByRO",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          "constType":parseJwt(localStorage.access_token).constituencyType,
          "constNo":  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
          // "acNo":parseJwt(localStorage.access_token).authorizedAcs?.[0],
          // "pcNo":parseJwt(localStorage.access_token).authorizedPcs?.[0]

        },
      }),
    }),

    GetCountingSupervisorRoReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getCountigSuperwiserRo",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          "constType":parseJwt(localStorage.access_token).constituencyType,
          "constNo":  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
          // "acNo":parseJwt(localStorage.access_token).authorizedAcs?.[0],
          // "pcNo":parseJwt(localStorage.access_token).authorizedPcs?.[0]
        },
      }),
    }),

    GetEpbScanningRoReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getEPostalBallotScanningByRO",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
          "constType":parseJwt(localStorage.access_token).constituencyType,
          "constNo":  parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
          // "acNo":parseJwt(localStorage.access_token).authorizedAcs?.[0],
          // "pcNo":parseJwt(localStorage.access_token).authorizedPcs?.[0]
        },
      }),
    }),
    getstateWiseSummaryReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getStateWiseTotalCount",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
        },
      }),
    }),
    getRecordUnitWiseEciReport: builder.mutation({
      query: (data) => ({
        
        url: `/v1/public/etpbs-reports/getRecordUnitData`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
        //  'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getEpbScannedStatewiseEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getScanningCompleted`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getstateWiseScanningCompletedReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getScanningCompletedSataeWise",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
        },
      }),
    }),
    getSummaryEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getSummaryReportPhaseWise`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getDetailedEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getDetailedReportPhaseWise`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getEpbDownloadPhasewiseEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getEpbStatusPhaseWise`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getEpbPrecountingSummaryEciReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getScanningSummaryReport`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getScannedUpdate: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/updateCsDetails",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
        },
      }),
    }),
    getEpbdownloadingPhaseWiseNodalReport: builder.mutation({
      query: (data) => ({
        url: `v1/public/etpbs-reports/getStatePhaseWiseReport`,
        method: "POST",
        body:data,
        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
          'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
      }),
    }),
    getStateWiseEpbReceviedByROReport: builder.query({
      query: () => ({
        url: "/v1/public/etpbs-reports/getStateWiseEpbReceviedByROReport",
        method: "GET",

        headers: {
          'Authorization': 'Bearer ' + localStorage.access_token,
          'Content-Type': 'application/json',
         'currentrole' : localStorage.userrole,
        },
      }),
    }),
  }),
})

export const {
  useGetEpbGenerationDownloadCeoReportQuery,
  useGetEpbScanningCeoReportQuery,
  useGetCountingSupervisorCeoReportQuery,
  useGetCountingSupervisorDeoReportQuery,
  useGetEpbGenerationDownloadDeoReportQuery,
  useGetEpbScanningDeoReportQuery,
  useGetEpbGenerationEciReportMutation,
  useGetEpbDownloadForceWiseEciReportMutation,
  useGetEpbDownloadUnitOfficeWiseEciReportMutation,
  useGetEpbScanningEciReportMutation,
  useGetEpbDownloadStatewiseEciReportMutation,
  useGetEpbDownloadRecordOfficeWiseEciReportMutation,
  useGetCountingSupervisorEciReportMutation,
  useGetEpbGenerationDownloadRoReportQuery,
  useGetErollFinalizationStatusCeoReportsMutation,
  useGetCountingSupervisorRoReportQuery,
  useGetForceWingDataQuery,
  useGetEpbScanningRoReportQuery,
  useGetStatesStatusForceWiseQuery,
  useGetErollFinalizationStatusDeoReportsMutation,
  useGetstateWiseSummaryReportQuery,
  useGetRecordUnitWiseEciReportMutation,
  useGetEpbScannedStatewiseEciReportMutation,
  useGetstateWiseScanningCompletedReportQuery,
  useGetDetailedEciReportMutation,
  useGetSummaryEciReportMutation,
  useGetEpbDownloadPhasewiseEciReportMutation,
  useGetEpbPrecountingSummaryEciReportMutation,
  useGetScannedUpdateQuery,
  useGetEpbdownloadingPhaseWiseNodalReportMutation,
  useGetStateWiseEpbReceviedByROReportQuery
} = reportsServicesApi;
